//=include  ../dataLayer.js
import DataLayer from '../dataLayer'

export default class HomeTracker {


    constructor() {
        this.analytics = window.__pt.fn.analytics;
        this.events = window.__pt.fn.analytics.events;
        this.settings = window.__pt.settings;
        this.pages = window.__pt.fn.analytics.pages;
    }


    selectContent(btn, text) {
        const data = {
            content_type: this.events.button,
            element: `${btn} :: ${text}`,
            event: this.events.trackEvent,
            eventName: this.events.selectContent,
            layer: this.settings.page
        }
        this.analytics.set(data.event, data);
    }


    selectRecentSearch(search) {

        if (!search.box || !search.box.pax) {
            return;
        }
    
        const data = {
            content_type: this.events.link,
            element: `recent_search::<<${search.box.destination}>>`,
            event: this.events.trackEvent,
            eventName: this.events.selectContent,
            layer: this.events.hotels,
            page_type: this.settings.page,
            field_destination_name: search.place.displayText,
            field_destination_id: search.place.id,
            field_hotel_name: search.place.displayText,
            field_hotel_id: search.IdG || search.place.id,
            field_date1: search.box.checkIn,
            field_date2: search.box.checkOut,
            field_rooms: Array.isArray(search.box.pax) ? search.box.pax.length : 1,
            field_total_nights: this.countNight(search.box.checkIn, search.box.checkOut),
            travelers_adults: Array.isArray(search.box.pax)
                ? search.box.pax.reduce((prev, item) => prev + item.adults, 0)
                : search.box.pax.adults,
            travelers_children: Array.isArray(search.box.pax)
                ? search.box.pax.reduce((prev, item) => prev + item.children.length, 0)
                : search.box.pax.children.length
        }
    
        this.analytics.set(data.event, data);
    }
    

    userInteraction(element) {
        const data = {
            event: `ga4.${this.events.trackEvent}`,
            eventName: this.events.user_interaction,
            eventParams: {
                action: this.events.click,
                element: element,
                content_type: this.events.link,
                page_type: this.pages[this.settings.page],
                layer: this.events.home
            }
        };

        this.analytics.set(null, { eventParams: null });
        this.analytics.set(data.event, data);
    }

    userViewPromotions(promotions) {
        let data = {
            event: `ga4.${this.events.trackEvent}`,
            eventName: this.events.viewPromotion,
            eventParams: {
                promotion_id: 0,
                promotion_name: promotions.title,
                creative_name: promotions.description,
                creative_slot: promotions.title,
                element: promotions.title,
                currency: this.settings.site.currency,
                value: 0,
                page_type: this.pages[this.settings.page],
                layer: this.events.hotels,
                timestamp: Date.now(),
                items: []
            }
        };

        promotions.cards.forEach((promo) => {
            data.eventParams.items.push(
                {
                    item_id: null,
                    item_name: promo.name,
                    item_brand: null,
                    item_category: promotions.cardType,
                    item_category2: null,
                    item_variant: null,
                    price: promo.price,
                    coupon: promo.promotionType
                }
            );
        });

        this.analytics.set(null, { eventParams: null });
        this.analytics.set(data.event, data);
    }

    userSelectPromotion(promotions, promo) {

        const data = {
            event: `ga4.${this.events.trackEvent}`,
            eventName: this.events.selectPromotion,
            eventParams: {
                action: this.events.click,
                promotion_id: null,
                promotion_name: promotions.title,
                creative_name: promotions.description,
                creative_slot: promotions.title,
                element: promotions.title,
                currency: this.settings.site.currency,
                value: null,
                page_type: this.pages[this.settings.page],
                layer: this.events.hotels,
                timestamp: Date.now(),
                items: [
                    {
                        item_id: promo.promotionType,
                        item_name: promo.name,
                        item_brand: null,
                        item_category: promotions.cardtype || 'promotion',
                        item_category2: promotions.cardtype || null,
                        item_variant: null,
                        price: promo.price,
                        coupon: promo.promotionType
                    }
                ]
            }
        };

        this.analytics.set(null, { eventParams: null });
        this.analytics.set(data.event, data);
    }
    selectRecap() {
        const data = {
            content_type: this.events.button,
            element: `recap2025_card`,
            event: this.events.trackEvent,
            eventName: this.events.selectContent,
            layer: this.settings.page
        }
        this.analytics.set(data.event, data);
    }

    //Helper functions

    countNight(checkIn, checkOut) {
        const diff = Math.abs(
            new Date(checkOut).getTime() - new Date(checkIn).getTime()
        );

        const nights = diff / (60 * 60 * 24 * 1000);

        return nights;
    }

}
